export default function AppSection() {
  return (
    <section id="app" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="w-full max-w-[1024px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 bg-gradient-to-br from-primary-500 to-primary-700 rounded-2xl p-8 md:p-12">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-heading text-white mb-4">随时随地，畅享观影</h2>
            <p className="text-sm md:text-base text-white/80 leading-relaxed mb-6">
              桃子视频移动端全面适配手机与平板浏览器，无需下载安装，打开即用。
              触屏手势优化让观影操作更顺手，躺在床上也能轻松追剧。支持投屏到电视，
              小屏变大屏，和家人朋友一起享受美好观影时光。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a href="#hero" className="inline-flex items-center gap-2 px-6 py-2.5 bg-white text-primary-600 font-medium rounded-full hover:bg-white/90 transition-all duration-200 cursor-pointer whitespace-nowrap text-sm">
                <i className="ri-smartphone-line text-lg"></i>
                手机端立即体验
              </a>
              <a href="#features" className="inline-flex items-center gap-2 px-6 py-2.5 bg-white/15 text-white border border-white/30 rounded-full hover:bg-white/25 transition-all duration-200 cursor-pointer whitespace-nowrap text-sm">
                <i className="ri-tv-line text-lg"></i>
                投屏使用指南
              </a>
            </div>
          </div>
          <div className="flex-shrink-0">
            <div className="relative w-48 h-80 md:w-56 md:h-96 rounded-2xl overflow-hidden border-4 border-white/30 shadow-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=Smartphone%20mockup%20showing%20a%20modern%20video%20streaming%20app%20interface%20with%20movie%20thumbnails%20and%20warm%20peach%20color%20scheme%2C%20clean%20UI%20design%2C%20floating%20phone%20on%20minimal%20background&width=560&height=960&seq=app-mockup-01&orientation=portrait"
                alt="桃子视频移动端界面预览"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}